/// ----------------------------------------------------------------------------------------
///Copyright (C) 2017 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics.
/// ----------------------------------------------------------------------------------------
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER  } from '@angular/core';
import { ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { TranslateI18Next, TranslateI18NextModule } from 'ngx-i18next/index';
import { BusyModule } from 'angular2-busy/index';
//import 'rxjs/Rx';
import {AccordionModule} from 'primeng/primeng';
import {AutoCompleteModule} from 'primeng/primeng';
import {BlockUIModule} from 'primeng/primeng';
import {BreadcrumbModule} from 'primeng/primeng';
import {ButtonModule} from 'primeng/primeng';
import {CalendarModule} from 'primeng/primeng';
import {CarouselModule} from 'primeng/primeng';
import {ChartModule} from 'primeng/primeng';
import {CheckboxModule} from 'primeng/primeng';
import {CodeHighlighterModule} from 'primeng/primeng';
import {SharedModule} from 'primeng/primeng';
import {ContextMenuModule} from 'primeng/primeng';
import {DataGridModule} from 'primeng/primeng';
import {DataListModule} from 'primeng/primeng';
import {DataScrollerModule} from 'primeng/primeng';
import {DataTableModule} from 'primeng/primeng';
import {DialogModule} from 'primeng/primeng';
import {DragDropModule} from 'primeng/primeng';
import {DropdownModule} from 'primeng/primeng';
import {EditorModule} from 'primeng/primeng';
import {FieldsetModule} from 'primeng/primeng';
import {FileUploadModule} from 'primeng/primeng';
import {GalleriaModule} from 'primeng/primeng';
import {GMapModule} from 'primeng/primeng';
import {GrowlModule} from 'primeng/primeng';
import {InplaceModule} from 'primeng/primeng';
import {InputMaskModule} from 'primeng/primeng';
import {InputSwitchModule} from 'primeng/primeng';
import {InputTextModule} from 'primeng/primeng';
import {InputTextareaModule} from 'primeng/primeng';
import {LightboxModule} from 'primeng/primeng';
import {ListboxModule} from 'primeng/primeng';
import {MegaMenuModule} from 'primeng/primeng';
import {MenuModule} from 'primeng/primeng';
import {MenubarModule} from 'primeng/primeng';
import {MessagesModule} from 'primeng/primeng';
import {MultiSelectModule} from 'primeng/primeng';
import {OrderListModule} from 'primeng/primeng';
import {OverlayPanelModule} from 'primeng/primeng';
import {PaginatorModule} from 'primeng/primeng';
import {PanelModule} from 'primeng/primeng';
import {PanelMenuModule} from 'primeng/primeng';
import {PasswordModule} from 'primeng/primeng';
import {PickListModule} from 'primeng/primeng';
import {ProgressBarModule} from 'primeng/primeng';
import {RadioButtonModule} from 'primeng/primeng';
import {RatingModule} from 'primeng/primeng';
import {ScheduleModule} from 'primeng/primeng';
import {SelectButtonModule} from 'primeng/primeng';
import {SlideMenuModule} from 'primeng/primeng';
import {SliderModule} from 'primeng/primeng';
import {SpinnerModule} from 'primeng/primeng';
import {SplitButtonModule} from 'primeng/primeng';
import {StepsModule} from 'primeng/primeng';
import {TabMenuModule} from 'primeng/primeng';
import {TabViewModule} from 'primeng/primeng';
import {TerminalModule} from 'primeng/primeng';
import {TieredMenuModule} from 'primeng/primeng';
import {ToggleButtonModule} from 'primeng/primeng';
import {ToolbarModule} from 'primeng/primeng';
import {TooltipModule} from 'primeng/primeng';
import {TreeModule} from 'primeng/primeng';
import {TreeTableModule} from 'primeng/primeng';
import { TreeDragDropService } from 'primeng/primeng';
import { TableModule } from 'primeng/table';


import {MediatorService} from './services/mediator.service';
import {ValidationService} from './services/validation.service';

import { HostApplication } from './host.application';
import { AzureADAuthReplyComponent } from './authentication/azure-active-directory/azure-ad-auth-reply/azure-ad-auth-reply.component';
import { AzureADAuthLoginComponent } from './authentication/azure-active-directory/azure-ad-auth-login/azure-ad-auth-login.component'
import { LoginComponent } from './authentication/login/login.component';
import { AzureADAuthLogoutComponent } from './authentication/azure-active-directory/azure-ad-auth-logout/azure-ad-auth-logout.component';


import { HydUser } from './models/user';
import {DeviceApiService} from  './services/Crestron.HydrogenAPI.DeviceApi.service';
import {GroupApiService} from './services/Crestron.HydrogenAPI.GroupApi.service';
import {LogApiService, LogEntry, Severity} from './services/Crestron.HydrogenAPI.LogApi.service'
import { DeviceMetaDataInfoApiClient } from './services/Crestron.HydrogenAPI.DeviceMetaDataInfoClient'
 

//Global Exception Handler
import {ExceptionHandler } from './services/exception-handler.service';
import { LogService } from './services/log.service';

//HTTP Request Tracking
import { HttpTracker } from './services/http-tracker.service';
import { Http, Response,RequestOptions, XHRBackend } from '@angular/http';

//Authorization
import { AuthorizationService } from './authorization/shared/authorization.service'
import { AuthorizationModule } from './authorization/authorization.module';

import {Injectable, Injector} from '@angular/core';

import { SharedModule as HydrogenSharedModule } from './shared/shared.module';
import { AccountApiService } from './services/Crestron.HydrogenAPI.AccountApi.service';
import { UserAPIService } from './services/Crestron.HydrogenAPI.UserApi.service';
import {SignalRService, SignalrWindow} from './services/signalR.service';
import {HydRoutingService} from './services/routing.service';

import { PolicyApiService } from './services/Crestron.HydrogenAPI.PolicyApi.service';

import { LicenseApiService } from './services/Crestron.HydrogenAPI.LicenseClient';
//YH 12/1/2016 Task 9542:Revamp Hydrogen Portal left hand side vertical
import { ContainersModule } from './containers/containers.module';
import { RoutingModule } from './host.routes';

import {HydrogenAppConfigService } from "./host.config.service";
import {LanguageService,TranslatedStringsService } from './services/language.service';

//YH 1/4/2017 Task 9540:Cache Hydrogen Account's Groups, Devices, etc. in H2 Portal
import {GroupStoreService} from './services/group-store/group-store.service';
import {DeviceStoreService} from './services/device-store/device-store.service';

//YH 1/16/2017 Implement user logged in guard
import {LoggedInGuard} from './authentication/login/loggedin-guard.service';
//YH 2/3/2017 Bug 118131 - Implement authorization refresh when access token expires
 import { DashboardModule } from './features/dashboard/dashboard.module';
//YH 3/24/2017 Bug 125858 - Change "Plain Old User" text to "Standard User"
import { hydLogoutComponent } from './authentication/logout/logout.component';
//YH 5/9/2017 Bug 129033 - User Automatically Logged out of the Portal even when the user was Active few minutes before
import { AzureADAccessTokenRefreshService } from './authentication/azure-active-directory/azure-ad-access-token-refresh.service';


import {CUICommunicationServiceInterface} from './interfaces/cui-communication-service.interface';
import {CloudCommunicationServiceInterface} from './interfaces/cloud-communication-service.interface';
import {PermissionsService} from './authorization/permissions/permissions.service';
import { XiOApplicationInsightService } from './services/xioapplicationinsight.service';
import { PortalVersionService } from './services/portal-version.service';
import { FileuploadApiService } from './services/Crestron.HydrogenAPI.FileuploadApi.service';

import { BaseMenuComponent } from './features/base-component/base-menu/base-menu.component';
import { BaseDetailComponent } from './features/base-component/base-detail/base-detail.component';
import { ToggleDashboardComponent } from './features/dashboard/toggle-dashboard/toggle-dashboard.component';

var mediatorService = new MediatorService();



@NgModule({
  imports: [ 
        RoutingModule,          //YH 12/1/2016 Task 9542:Revamp Hydrogen Portal left hand side vertical //Moved top due to Anglar 4 upgrade
		    TranslateI18NextModule,
        BusyModule,
        HydrogenSharedModule,
        //PoliciesModule,
        ContainersModule,
        DashboardModule,
        BrowserModule,
        FormsModule,
        HttpModule,
        AccordionModule,
        AutoCompleteModule,
        BlockUIModule,
        BreadcrumbModule,
        ButtonModule,
        CalendarModule,
        CarouselModule,
        ChartModule,
        CheckboxModule,
        CodeHighlighterModule,
        SharedModule,
        ContextMenuModule,
        DataGridModule,
        DataListModule,
        DataScrollerModule,
        DataTableModule,
        DialogModule,
        DragDropModule,
        DropdownModule,
        EditorModule,
        FieldsetModule,
        FileUploadModule,
        GalleriaModule,
        GMapModule,
        GrowlModule,
        InplaceModule,
        InputMaskModule,
        InputSwitchModule,
        InputTextModule,
        InputTextareaModule,
        LightboxModule,
        ListboxModule,
        MegaMenuModule,
        MenuModule,
        MenubarModule,
        MessagesModule,
        MultiSelectModule,
        OrderListModule,
        OverlayPanelModule,
        PaginatorModule,
        PanelModule,
        PanelMenuModule,
        PasswordModule,
        PickListModule,
        ProgressBarModule,
        RadioButtonModule,
        RatingModule,
        ScheduleModule,
        SelectButtonModule,
        SlideMenuModule,
        SliderModule,
        SpinnerModule,
        SplitButtonModule,
        StepsModule,
        TabMenuModule,
        TabViewModule,
        TerminalModule,
        TieredMenuModule,
        ToggleButtonModule,
        ToolbarModule,
        TooltipModule,
        TreeModule,
        TreeTableModule,
        TableModule,
        ReactiveFormsModule ,
        AuthorizationModule,
        BrowserAnimationsModule

    ],
    declarations: [
      HostApplication,
      BaseMenuComponent,
      BaseDetailComponent,
        AzureADAuthReplyComponent,
        AzureADAuthLoginComponent,
        LoginComponent,
        AzureADAuthLogoutComponent,
      hydLogoutComponent,
      ToggleDashboardComponent
    ],
    bootstrap: [ HostApplication ],
    providers: [
      AccountApiService,
        AuthorizationService,
        TreeDragDropService,
        HydUser,
        LogService,
        DeviceApiService,
        GroupApiService,
        LogApiService,
        DeviceMetaDataInfoApiClient,
        UserAPIService,
        SignalRService,
        HydRoutingService,
        PolicyApiService,
        LicenseApiService,
        HydrogenAppConfigService,
        LanguageService,
        TranslatedStringsService, //YH 2/7/2017 Load translation file before presenting UI pages
        GroupStoreService,  //YH 1/4/2017 Task 9540:Cache Hydrogen Account's Groups, Devices, etc. in H2 Portal
        DeviceStoreService, //MM
        LoggedInGuard,  //YH 1/16/2017 Implement user logged in guard
        AzureADAccessTokenRefreshService,  //YH 5/9/2017 Bug 129033
        ValidationService,
        PermissionsService,
        PortalVersionService,
      FileuploadApiService,
        { provide: MediatorService, useValue: mediatorService },
        {provide: ErrorHandler, useClass: ExceptionHandler},
        {provide : Http,
                    useFactory: (backend: XHRBackend, defaultOptions: RequestOptions,  injector: Injector, hydUser:HydUser) => {
                        //return new HttpTracker(backend, defaultOptions, injector)
                        return new HttpTracker(backend, defaultOptions, injector,hydUser)
                    },
                    deps: [XHRBackend, RequestOptions, Injector,HydUser ]
                  },
        {provide:SignalrWindow, useValue: window},
        { provide: 'Window', useValue: window },
        {
            provide: APP_INITIALIZER,
            useFactory: (config: HydrogenAppConfigService) => () => config.loadConfig(),
            deps: [HydrogenAppConfigService],
            multi: true
        },
        XiOApplicationInsightService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class HostModule { }



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/host.module.ts